export function downloadBlobFile(blob: Blob, fileName?: string) {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName || blob.type;
  link.click();
  link.remove();
}